import { Helmet } from '@dr.pogodin/react-helmet';

import { PageHeading, PageWrap } from '../../components';
import { useClientData } from '../../contexts';
import CompanyOverview from './CompanyOverview';

export default function DashboardPage() {
  const { clientCompanies } = useClientData();

  return (
    <PageWrap>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <PageHeading>My Companies</PageHeading>

      {clientCompanies.map((company) => (
        <CompanyOverview key={company.slug} company={company} />
      ))}
    </PageWrap>
  );
}
